<template>
  <div class="withdrawl-container">
    <div class="header">
      <div class="title">提现金额</div>
      <div class="input">
        <span>¥</span>
        <input type="number" v-model.number="inputValue" />
      </div>
      <div class="tip">
        可提现￥ {{ maxMoney }}元,收到的保证金￥{{ frzBalance }}，暂不可提现的货款￥{{
          lockingBalance
        }}
      </div>
    </div>
    <div class="bottom">
      <p class="desc">提现说明：资金将提现到绑定的银行卡，提现金额不能大于可提现金额</p>
      <div class="submit-btn" @click="submitAction">提交申请</div>
    </div>
  </div>
</template>

<script>
import { accountView, personaldrawcash } from '@/api/capital';
import { Toast } from 'vant';
export default {
  data() {
    return {
      withdrawalMoney: null,
      maxMoney: 0.0,
      frzBalance: 0.0,
      lockingBalance: 0.0,
      inputValue: null,
    };
  },
  created() {
    this.loadAccountDetail();
  },
  methods: {
    loadAccountDetail() {
      accountView().then(res => {
        if (res.data.settleAccountTo) {
          this.maxMoney = Number(res.data.settleAccountTo.avlBalance);
          this.frzBalance = Number(res.data.settleAccountTo.frzBalance);
          this.lockingBalance = Number(res.data.settleAccountTo.lockingBalance) || 0;
        }
      });
    },
    submitAction() {
      if (!this.inputValue) {
        Toast('请输入正确的金额');
        return;
      }
      if (this.inputValue > this.maxMoney) {
        Toast('可用余额不足');
        return;
      }
      Toast.loading({
        message: '提现中...',
        forbidClick: true,
      });
      personaldrawcash({ transAmt: this.inputValue })
        .then(res => {
          Toast(res.data.message);
          this.$router.go(-1);
        })
        .finnally(() => {
          Toast.clear();
        });
    },
  },
};
</script>

<style lang="less" scoped>
.withdrawl-container {
  padding-top: 10px;
  box-sizing: border-box;
  .header {
    background-color: white;
    padding: 20px;
    .title {
      font-size: 16px;
      color: #666666;
    }
    .input {
      display: flex;
      margin-top: 45px;
      padding-bottom: 5px;
      border-bottom: 1px solid #e5e5e5;
      overflow: hidden;
      span {
        margin-right: 10px;
        font-weight: 600;
        color: #000000;
        font-size: 34px;
      }
    }
    .tip {
      font-size: 15px;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
      margin-top: 11px;
    }
  }
  .bottom {
    box-sizing: border-box;
    padding: 20px;
    .desc {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
    .submit-btn {
      margin-top: 40px;
      width: 100%;
      height: 44px;
      line-height: 44px;
      background-color: #222222;
      color: white;
      font-size: 14px;
      text-align: center;
      border-radius: 4px;
    }
  }
}
</style>
